import * as Sentry from "@sentry/nextjs";
import { AxiosResponse } from "axios";
import { toast } from "react-toastify";
import { useSWRConfig } from "swr";

import { useErrorToaster } from "src/common/components/ErrorDetails";
import { client, endpoint } from "src/lib/bridgeClient";
import { SERVER_COMM_ERROR } from "src/lib/error";

const deleteTemplate = async (client: Client, templateId: number) => {
  return await client(endpoint.deleteWorkflowTemplate(templateId), "DELETE");
};

const deleteOrgTemplate = async (client: Client, templateId: number) => {
  return await client(endpoint.deleteOrgWorkflowTemplate(templateId), "DELETE");
};

export const useDeleteTemplate = () => {
  const toastError = useErrorToaster();
  const { mutate } = useSWRConfig();

  return async (id: number, name: string): Promise<AxiosResponse> => {
    let response: AxiosResponse;

    try {
      response = await deleteTemplate(client, id);

      mutate(endpoint.myWorkflowTemplates);

      toast.success(`Workflow template deleted: ${name}`);
    } catch (error) {
      if (error?.response?.data?.error) {
        toastError("Failed to delete workflow template", error?.response?.data?.error);
      } else {
        toast.error(`Request failed: ${SERVER_COMM_ERROR}`);
        Sentry.captureException(error);
      }

      return error.response;
    }

    return response;
  };
};

export const useDeleteOrgTemplate = () => {
  const toastError = useErrorToaster();
  const { mutate } = useSWRConfig();

  return async (id: number, name: string): Promise<AxiosResponse> => {
    let response: AxiosResponse;

    try {
      response = await deleteOrgTemplate(client, id);

      mutate(endpoint.myOrgWorkflowTemplates);

      toast.success(`Workflow template deleted: ${name}`);
    } catch (error) {
      if (error?.response?.data?.error) {
        toastError("Failed to delete workflow template", error?.response?.data?.error);
      } else {
        toast.error(`Request failed: ${SERVER_COMM_ERROR}`);
        Sentry.captureException(error);
      }

      return error.response;
    }

    return response;
  };
};
